var _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeStudioSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M42,32.84V15.945c0-1.081-0.581-2.078-1.521-2.61l-15-8.497c-0.917-0.52-2.04-0.52-2.957,0 l-15,8.497C6.581,13.867,6,14.864,6,15.945V32.84c0,1.081,0.581,2.078,1.521,2.61l15,8.497c0.917,0.52,2.04,0.52,2.957,0l15-8.497 C41.419,34.918,42,33.921,42,32.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,37.941c-0.682,0-1.363-0.172-1.972-0.517l-8.821-4.997c-1.251-0.708-2.029-2.042-2.029-3.48 v-9.895c0-1.438,0.777-2.772,2.029-3.48l8.821-4.997c1.216-0.689,2.726-0.689,3.943,0l8.821,4.997 c1.251,0.708,2.029,2.042,2.029,3.48v9.895c0,1.438-0.777,2.772-2.029,3.48l-8.821,4.997C25.363,37.77,24.682,37.941,24,37.941z M24,12.057c-0.341,0-0.682,0.087-0.985,0.259l-8.822,4.997c-0.625,0.354-1.014,1.021-1.014,1.74v9.895 c0,0.72,0.389,1.386,1.014,1.74l8.821,4.997c0.608,0.344,1.364,0.344,1.971,0l8.822-4.997c0.625-0.354,1.014-1.021,1.014-1.74 v-9.895c0-0.72-0.389-1.386-1.014-1.74l-8.821-4.997C24.682,12.144,24.341,12.057,24,12.057z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20,18 20,30 30,24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeStudioSvgrepoCom);
export default __webpack_public_path__ + "static/media/youtube-studio-svgrepo-com.25726a42b92a90279f0f893fa92e4a87.svg";
export { ForwardRef as ReactComponent };